module.exports = __webpack_public_path__ + "img/bodega.83994d66.png";